var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.5C19.3672 7.5 20.5 8.63281 20.5 10V13.75C20.5 14.4531 19.9141 15 19.25 15H18V18.75C18 19.4531 17.4141 20 16.75 20H4.25C3.54688 20 3 19.4531 3 18.75V15H1.75C1.04688 15 0.5 14.4531 0.5 13.75V10C0.5 8.63281 1.59375 7.5 3 7.5H18ZM15.5 17.5V13.75H5.5V17.5H15.5ZM17.375 11.5625C17.8828 11.5625 18.3125 11.1719 18.3125 10.625C18.3125 10.1172 17.8828 9.6875 17.375 9.6875C16.8281 9.6875 16.4375 10.1172 16.4375 10.625C16.4375 11.1719 16.8281 11.5625 17.375 11.5625ZM5.5 2.5V6.25H3V1.25C3 0.585938 3.54688 0 4.25 0H14.9531C15.3047 0 15.6172 0.15625 15.8516 0.390625L17.6094 2.14844C17.8438 2.38281 18 2.69531 18 3.04688V6.25H15.5V3.55469L14.4453 2.5H5.5Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.854aca0c06aaf38817489a033502e117.svg";
export { ForwardRef as ReactComponent };